import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

import Content from '../common/Content';
import GridCharts from '../content/grid/GridCharts';
import GridPlaylists from '../content/grid/GridPlaylists';
import GridArtists from '../content/grid/GridArtists';
import GridLabels from '../content/grid/GridLabels';
import ListV2 from '../content/list/ListV2';
import ListSearchTracks from '../content/list/ListSearchTracks';

function ConnectedSearchRoute({ width, height }) {
  return (
    <Switch>
      <Route path="/search/artists-base/:value" render={ props => (
        <Content name={`Artist Results`}>
          <GridArtists id={`search-artists-${props.match.params.value}`} width={width}
            height={ height - (Config.TAB_BAR_GUTTER * 4) }
            perPage={100} pathApi={`/catalog/search/?per_page=40&type=artists&q=${props.match.params.value}`}
            isBaseRootApi={true}
            style={{marginTop: 20}}
          />
        </Content>
      )} />
      {/* <Route path="/search/artists-base/" render={ props => (
        <Content name={`Artist Results`}>
          <GridArtists id={`search-artists-${props.match.params.value}`} width={width}
            height={ height - (Config.TAB_BAR_GUTTER * 3) }
            perPage={100} pathApi={`/catalog/artists/?per_page=100`}
            isBaseRootApi={true}
            style={{marginTop: 20}}
          />
        </Content>
      )} /> */}
      <Route path="/search/artists/:value" render={ props => (
        <Content name={`Artist Results`}>
          <GridArtists id={`search-artists-${props.match.params.value}`} width={width}
            height={ height - (Config.TAB_BAR_GUTTER * 4) }
            perPage={100} pathApi={`/artists?count=50&q=${props.match.params.value}`}
            isBaseRootApi={false}
            style={{marginTop: 20}}
          />
        </Content>
      )} />
      {/* <Route path="/search/artists/" render={ props => (
        <Content name={`Artist Results`}>
          <GridArtists id={`search-artists-${props.match.params.value}`} width={width}
            height={ height - (Config.TAB_BAR_GUTTER * 3) }
            perPage={100} pathApi={`/artists/?count=100`}
            isBaseRootApi={false}
            style={{marginTop: 20}}
          />
        </Content>
      )} /> */}
      <Route path="/search/labels-base/:value" render={ props => (
        <Content name={`Label Results`}>
          <GridLabels id={`search-labels-${props.match.params.value}`} width={width}
            height={ height - (Config.TAB_BAR_GUTTER * 4) }
            perPage={100} pathApi={`/catalog/search/?per_page=40&type=labels&q=${props.match.params.value}`}
            isBaseRootApi={true}
            style={{marginTop: 20}}
          />
        </Content>
      )} />
      {/* <Route path="/search/labels-base/" render={ props => (
        <Content name={`Label Results`}>
          <GridLabels id={`search-labels-${props.match.params.value}`} width={width}
            height={ height - (Config.TAB_BAR_GUTTER * 4) }
            perPage={100} pathApi={`/catalog/labels/?per_page=100`}
            isBaseRootApi={true}
            style={{marginTop: 20}}
          />
        </Content>
      )} /> */}
      <Route path="/search/labels/:value" render={ props => (
        <Content name={`Label Results`}>
          <GridLabels id={`search-labels-${props.match.params.value}`} width={width}
            height={ height - (Config.TAB_BAR_GUTTER * 4) }
            perPage={100} pathApi={`/labels?count=50&q=${props.match.params.value}`}
            isBaseRootApi={false}
            style={{marginTop: 20}}
          />
        </Content>
      )} />
      {/* <Route path="/search/labels/" render={ props => (
        <Content name={`Label Results`}>
          <GridLabels id={`search-labels-${props.match.params.value}`} width={width}
            height={ height - (Config.TAB_BAR_GUTTER * 4) }
            perPage={100} pathApi={`/labels?count=100`}
            isBaseRootApi={false}
            style={{marginTop: 20}}
          />
        </Content>
      )} /> */}
      <Route path="/search/playlists-base/:value" render={ props => (
        <Content name={`Playlist Results`}>
          <GridCharts id={`search-playlists-${props.match.params.value}`} width={width}
            height={ height - (Config.TAB_BAR_GUTTER * 3) }
            perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&name=${props.match.params.value}`}
            style={{marginTop: 20}}
          />
        </Content>
      )} />
      <Route path="/search/playlists-base/" render={ props => (
        <Content name={`Playlist Results`}>
          <GridCharts id={`search-playlists-${props.match.params.value}`} width={width}
            height={ height - (Config.TAB_BAR_GUTTER * 3) }
            perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100`}
            style={{marginTop: 20}}
          />
        </Content>
      )} />
       <Route path="/search/playlists/:value" render={ props => (
        <Content name={`Playlist Results`}>
          <GridPlaylists id={`search-playlists-${props.match.params.value}`} width={width}
            height={ height - (Config.TAB_BAR_GUTTER * 3) }
            perPage={100} pathApi={`/charts?count=100&is_approved=true&q=${props.match.params.value}`}
            style={{marginTop: 20}}
          />
        </Content>
      )} />
      <Route path="/search/playlists/" render={ props => (
        <Content name={`Playlist Results`}>
          <GridPlaylists id={`search-playlists-${props.match.params.value}`} width={width}
            height={ height - (Config.TAB_BAR_GUTTER * 3) }
            perPage={100} pathApi={`/charts?count=100&is_approved=true`}
            style={{marginTop: 20}}
          />
        </Content>
      )} />
      <Route path="/search/tracks-base/:value" render={ props => (
        <ListV2
          title={`Track Results`}
          titleContainerClassName={`title-border-bottom`}
          pathApi={`/catalog/search/?q=${props.match.params.value}&type=tracks&per_page=50`  /*`/catalog/tracks?name=${props.match.params.value}&per_page=100`*/}
          sortable={false}
          id={`search-tracks-${props.match.params.value}`}
          width={width}
          height={height - (Config.TAB_BAR_GUTTER * 2.5)}
          size={Config.LIST_ROW_HEIGHT}
          style={{marginTop: 0}}
          filtersStyle={{position: `absolute`, top: 13, right: 0}}
          panelStyle={{margin: `8px 0px 16px 0px`}}
          isLoadMore={false}
          type={`Full`}
          orderBy={[`title`, `label`, `genre_s`, `release`]}
          filters={[`mix_name`, `artists_s`, `label`, `genre_s`, `bpm`, `key_convert`]}
        />
      )} />
      <Route path="/search/tracks/:value" render={ props => (
        <ListSearchTracks
          title={`Track Results`}
          titleClassName={`title-border-bottom`}
          pathApi={`/tracks?count=100&is_available_for_streaming=true&q=${props.match.params.value}`}
          id={`search-tracks-${props.match.params.value}`}
          width={width}
          height={height - (Config.TAB_BAR_GUTTER * 2.5)}
          size={Config.LIST_ROW_HEIGHT}
          style={{marginTop: 0}}
          type={`Full`}
          filtersStyle={{position: `absolute`, top: -8, right: 0}}
          panelStyle={{margin: `8px 0px 16px 0px`}}
          orderBy={[`title`, `artists_s`, `label`, `genre_s`, `bpm`, `release`]}
          filters={[`mix_name`, `artists_s`, `label`, `genre_s`, `bpm`, `key_convert`]}
        />
      )} />

    </Switch>
  );
}

ConnectedSearchRoute.propTypes = {
  width: PropTypes.any,
  height: PropTypes.any
}

const SearchRoute = connect(
  state => ({
    width: state.dimension.width,
    height: state.dimension.height
  })
)(ConnectedSearchRoute);

export default SearchRoute;
